import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples

// Images
import bgImage from "assets/images/bg-presentation.jpg";
import logo from "assets/images/LOGO-Icontec-2019_ver_pos.png";
import EventosTable from "./UsuariosForoReport";
function IndexRport() {
  return (
    <>
      <MKBox
        minHeight="85vh"
        width="100%"
        sx={{
          position: "relative",
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",

          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.65)", // Filtro oscuro para mejorar contraste
            zIndex: 0.5,
          },
        }}
      >
        <Container sx={{ position: "relative", zIndex: 2 }}>
          <Grid container item xs={12} lg={12} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography
              variant="h1"
              color="white"
              mt={-2}
              mb={2}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              XVI Foro Internacional de Calidad 2025
              <br></br>
              <img width={"200px"} src={logo} />
            </MKTypography>

            <MKTypography
              variant="h5"
              color="white"
              fontWeight="light"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Descubre las tendencias y desafíos en calidad, transformación digital e innovación.
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={2}
            >
              📅 27 - 29 de agosto de 2025 | 📍 Cartagena, Colombia
            </MKTypography>
            <br></br>
          </Grid>
        </Container>
      </MKBox>

      <Card
        id="information-section"
        sx={{
          p: 3,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.9),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <EventosTable />
      </Card>
    </>
  );
}

export default IndexRport;
